import { IPC as IPCBase, COMMAND as COMMANDBASE } from '../../common/ipc';
import Logger from '../../common/logger';
import { CommonConfig } from '../../common/config';
import { WIDGET_ACTIONS } from '../../child/components/layers/widget/types';

export const COMMAND = COMMANDBASE;

/**
 * IPC hander for parent window. Enables message queueing while child iframe is not loaded yet.
 */
class IPC extends IPCBase {
    constructor() {
        super();

        this.childReady = false;
        this.messageQueue = [];
        this.currentStateResolve = [];
        this.singlePage = false;
    }

    setSinglePage() {
        this.singlePage = true;
    }

    remoteWindow() {
        if (this.singlePage) {
            return window;
        }
        const iframe = document.getElementById(CommonConfig.iFrameId);
        return iframe.contentWindow;
    }

    source() {
        return 'oplwidget-parent';
    }

    target() {
        return 'oplwidget-child';
    }

    postMessage(json) {
        if (this.childReady) {
            Logger.log('[IPC] Parent sent: ' + JSON.stringify(json));
            super.postMessage(json);
        } else {
            Logger.log('[IPC] Parent enqueue: ' + JSON.stringify(json));

            // enqueue message until iframe is loaded
            this.messageQueue.push(json);
        }
    }

    messageHandler(e) {
        if (super.messageHandler(e)) {
            switch (e.data.command) {
                case COMMAND.READY:
                    this.actionReady();
                    // iframe has been loaded
                    break;
                case WIDGET_ACTIONS.STATE:
                    this.currentStateResolve.forEach((resolve) => {
                        resolve(e.data.data);
                    }, this);
                    this.currentStateResolve = [];
                    break;
                default:
                    break;
            }
        }
    }

    /** Widget is ready for receiving messages */
    actionReady() {
        Logger.log('[IPC] Child ready');
        this.childReady = true;
        this.fireMessage();
    }

    /** Fire registered messages */
    fireMessage() {
        if (this.childReady) {
            this.messageQueue.forEach((json) => {
                Logger.log('[IPC] Parent sent: ' + JSON.stringify(json));
                super.postMessage(json);
            }, this);
            // clear queue
            this.messageQueue = [];
        }
    }

    getCurrentState() {
        return new Promise((resolve, reject) => {
            this.sendEvent(WIDGET_ACTIONS.GETSTATE);
            this.currentStateResolve.push(resolve);
            setTimeout(() => {
                reject(Error('Widget not responding'));
            }, 10 * 1000);
        });
    }
}

export default new IPC(); // singleton
